import { render, staticRenderFns } from "./payedMovie.vue?vue&type=template&id=e45e4736"
import script from "./payedMovie.vue?vue&type=script&lang=js"
export * from "./payedMovie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports